function deferFilterjQuery(retryCount) {
    retryCount = retryCount || 0;
    var maxRetries = 100;
    if (window.jQuery) {
        var $ = window.jQuery;
        $(function(){
          // On load/reload
          var pt_on_load = function() {
            // Check for Safari
            if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
                $(".filter-menu").addClass("is-safari");
            }
          
            // Accordion
            

            // Search
            $('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

            // Drop downs
            $('.pt-display-dropdown').each(function( index ) {
                $(this).find('h4').after($(this).find('.filter-clear'));
            });

            $('.pt-display-dropdown .scroll-content').each(function( index ) {
              if($(this).parent().find('.menu-trigger').length === 0) {
                if($(this).find('li.selected').length) {
                  var selected = $.map(
                    $(this).find('li.selected a'),
                    function(element){
                      return $(element).text();
                    }
                  ).join(", ");

                  if (selected.length < 30) {
                    $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">' + selected +'</div>');
                  } else {
                    $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">' + $(this).find('li.selected').length + ' Selected </div>');
                  }
                }
                else {
                  $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">'+ $(this).closest('.filter-group').find('h4').text() +'</div>');
                }
              }
            });

            //Sticky Mode
            

            // View more
            

            $('.filter-menu li a').attr('title', function() {
              return ($(this).closest('li').hasClass('selected') ? "Clear filter: " : "Add filter: ") + $(this).text();
            });

            // Handle nested filters
            var splitPath = function(url) {
              var splitUrl =  url.split('?')[0].split('#')[0].split('/');
              return splitUrl;
            }

            var getCollection = function(url) {
              var splitUrl = splitPath(url);
              return splitUrl[2];
            }

            var getTags = function(url) {
              var splitUrl = splitPath(url);
              return (splitUrl[3] || '').split('+');
            }

            var getCommonCollection = function(url_top, url_nested) {
              var collection_top = getCollection(url_top);
              var collection_nested = getCollection(url_nested);
              if (collection_top !== collection_nested) {
                return 'all';
              }
              return collection_top;
            }

            var getCommonTags = function(url_top, url_nested) {
              var tags_top = getTags(url_top);
              var tags_nested = getTags(url_nested);

              return tags_top.filter(function(n) {
                return tags_nested.indexOf(n) > -1;
              });
            }

            var getCommonUrl = function(url_top, url_nested) {
              var val = '/collections/' + getCommonCollection(url_top, url_nested) + '/' + getCommonTags(url_top, url_nested).join('+');

              var lastChar = val.slice(-1);
                    if (lastChar == '/') {
                    val = val.slice(0, -1);
                }

              return val;
            }

            var clearNestedParent = $('.pt-display-nested').prev().each(function() {
              var clearNested = $(this).next().find('a.filter-clear').attr('href');
              if (!clearNested) return;
              var clearLink = $(this).find('a.filter-clear');
              clearLink.attr('href', getCommonUrl(clearLink.attr('href'), clearNested))
              var filterLinks = $(this).find('li.selected .collection-name a').each(function() {
                $(this).attr('href', getCommonUrl($(this).attr('href'), clearNested));
              })
            })
          }

          pt_on_load();

          // Accumulate filter selections; apply only on "Aplicar", clear on "Eliminar todos" (desktop + mobile)
          $(document).on('click', '.filter-menu .filter-group li.collection-container a', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $(this).closest('li').toggleClass('selected');
          });
          // Also allow clicking the row (e.g. género) so selection is registered even if link click is captured
          $(document).on('click', '.filter-menu .filter-group-plp-genero li.collection-container .collection-name', function(e) {
            if (e.target.tagName === 'A' || e.target.closest('a')) return;
            e.preventDefault();
            e.stopPropagation();
            $(this).closest('li').toggleClass('selected');
          });
          $(document).on('click', '.filter-menu .filter-group a.filter-clear', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $(this).closest('.filter-group').find('li.collection-container').removeClass('selected');
          });
          $(document).on('click', '.filter-menu .pt-filter-clear-all', function(e) {
            e.preventDefault();
            var $menu = $(this).closest('.filter-menu');
            $menu.find('li.collection-container').removeClass('selected');
            var pathParts = window.location.pathname.split('/').filter(Boolean);
            var baseHandle = (pathParts[0] === 'collections' && pathParts[1]) ? pathParts[1] : 'all';
            window.location = window.location.origin + '/collections/' + baseHandle;
          });
          function resolveFullHref(href, currentPathname) {
            if (!href || href === '#') return '';
            if (href.indexOf('http') === 0) return href;
            var origin = window.location.origin;
            if (href.charAt(0) === '/') return origin + href;
            if (href.charAt(0) === '?') return origin + (currentPathname || window.location.pathname) + href;
            return origin + '/' + href;
          }
          function pathSegmentsFromUrl(fullHref) {
            var pathOnly = fullHref.split('?')[0].split('#')[0];
            if (pathOnly.indexOf('http') === 0) {
              try { pathOnly = new URL(fullHref).pathname; } catch (err) {}
            }
            return pathOnly.split('/').filter(Boolean);
          }
          $(document).on('click', '.filter-menu .pt-apply-btn', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var $menu = $(this).closest('.filter-menu');
            var $form = $(this).closest('form');
            var $selectedLis = $menu.find('li.collection-container.selected');
            var pathParts = window.location.pathname.split('/').filter(Boolean);
            var baseHandle = (pathParts[0] === 'collections' && pathParts[1]) ? pathParts[1] : 'all';
            var allTags = [];
            var searchParams = new URLSearchParams();
            var currentPath = window.location.pathname;

            // Include native facet checkboxes (e.g. Género, multiple tallas) and sort_by; use append so multiple values per param (e.g. talla M+L) are kept
            if ($form.length) {
              $form.find('input[type="checkbox"]:checked').each(function() {
                var name = $(this).attr('name');
                var val = $(this).val();
                if (name && val) searchParams.append(name, val);
              });
              var $sortSelect = $form.find('select[name="sort_by"]');
              if ($sortSelect.length && $sortSelect.val() && !searchParams.has('sort_by')) {
                searchParams.set('sort_by', $sortSelect.val());
              }
            }

            $selectedLis.each(function() {
              var $li = $(this);
              var addUrl = $li.data('add-url');
              var href = addUrl || $li.find('a').attr('href');
              if (!href || href === '#') return;
              var fullHref = resolveFullHref(href, currentPath);
              var p = pathSegmentsFromUrl(fullHref);
              if (p[0] === 'collections' && p[1] && p[2]) {
                allTags = allTags.concat(p[2].split('+'));
              }
              if (fullHref.indexOf('?') > -1) {
                var qs = fullHref.substring(fullHref.indexOf('?') + 1);
                try {
                  new URLSearchParams(qs).forEach(function(val, key) { searchParams.append(key, val); });
                } catch (err) {}
              }
            });
            // Ensure género (and other tag-based groups) tags are always included from data-add-url
            $menu.find('.filter-group-plp-genero li.collection-container[data-add-url].selected').each(function() {
              var addUrl = $(this).data('add-url');
              if (!addUrl) return;
              var fullHref = resolveFullHref(addUrl, currentPath);
              var segs = pathSegmentsFromUrl(fullHref);
              if (segs[0] === 'collections' && segs[1] && segs[2]) {
                allTags = allTags.concat(segs[2].split('+'));
              }
            });

            if ($selectedLis.length === 0 && searchParams.toString() === '') {
              window.location = window.location.origin + '/collections/' + baseHandle;
              return;
            }
            if ($selectedLis.length === 1 && searchParams.toString() === '') {
              var addUrl = $selectedLis.first().data('add-url');
              var href = addUrl || $selectedLis.first().find('a').attr('href');
              var fullUrl = resolveFullHref(href);
              if (fullUrl) window.location = fullUrl;
              return;
            }
            allTags = allTags.filter(Boolean);
            var uniqueTags = allTags.filter(function(t, i, a) { return a.indexOf(t) === i; });
            var searchStr = searchParams.toString();
            var pathSegment = '/collections/' + baseHandle + (uniqueTags.length ? '/' + uniqueTags.join('+') : '');
            var url = window.location.origin + pathSegment + (searchStr ? '?' + searchStr : '');
            window.location = url;
          });

          // Mobile filter button
          

          // Accordion
          

          // Search
          $(document).on('keyup', '.filter-group input.fm-search-box', function () {
            var value = this.value.toLowerCase();
            $(this).closest('.filter-group').find('li').each(function () {
              if ($(this).text().toLowerCase().search(value) > -1) {
                $(this).show(100);
              } else {
                $(this).hide(100);
              }
            });
          });

          // Drop downs
          $(document).on('click','.pt-display-dropdown .menu-trigger', function() {
            $(this).next('.scroll-content').css('top', $(this).position().top + $(this).height() + 1).css('left', $(this).position().left);
            $(this).next('.scroll-content').slideToggle('fast');
            $(this).next('.scroll-content').toggleClass('dropdown-open')
            if ($(this).next('.scroll-content').hasClass('dropdown-open')) {
              $(this).attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection expanded');
            } else {
              $(this).attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
            }
          });
          
          $(document).on('keydown', '.pt-display-dropdown .menu-trigger', function(e) {
            if(e.which == 13 || e.which == 32 ) { // return or space keys
              e.preventDefault();
              $(this).click();
            }
          });
          
          $(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function() {
            $(this).removeClass('dropdown-open');
            $(this).slideUp('fast');
            $(this).prev('.menu-trigger').attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
          });
          
          $(document).on('focusout', '.pt-display-dropdown .scroll-content li:last-child', function() {
            $(this).closest('.scroll-content').removeClass('dropdown-open');
            $(this).closest('.scroll-content').slideUp('fast');
            $(this).closest('.scroll-content').prev('.menu-trigger').attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
          });

          // Apply button (legacy: only when new footer is not present)
          

          // Ajax
          
      });
    }
    else if (retryCount < maxRetries) {
        setTimeout(function() { deferFilterjQuery(retryCount + 1); }, 50);
    }
}

deferFilterjQuery(0);
